import { Injectable, inject } from '@angular/core';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { AclService } from '../../../../../services/acl.service';
import { GroupObject, RuleObject } from '@it2go/types';
import { ActionEnum } from '../../../../../../../../types/src/authorization/enum/action.enum';
import { globalStore } from '../../../../shared/shared.global-service';
import { map, Observable } from 'rxjs';

interface State {
    allAvailableGroups: GroupObject[],
}

const defaultState: State = {
    allAvailableGroups: [],
};

export const KEY_JOIN = '__';

@Injectable()
export class AclGroupsPageStore extends ComponentStoreFactory<State> {

    tree$ = this.data.allAvailableGroups$.pipe(map((list) => {
        const nodes: Record<string, any> = {};
        list.forEach((it) => {
            nodes[it.id] = {
                ...it,
                extending: [],
                inherited: [],
            };
        });
        list.forEach((it) => {
            it.children.forEach((child) => {
                nodes[it.id].extending?.push(nodes[child]);
            });
        });

        const res = Object.values(nodes);
        this.addInherited(res, new Set());

        return res;
    }));

    organizationGroups$ = this.tree$.pipe(map((it) => it.filter((it) => it.organizationId !== null)));

    // TODO Losos !important
    // allResources$: Observable<{
    //     resource: string;
    //     read: boolean;
    //     create: boolean;
    //     update: boolean;
    //     delete: boolean
    // }[]> = globalStore.select(selectRules).pipe(map((it) => {
    //     const allActions = Object.values(ActionEnum);
    //     const rules: any[] = [];
    //
    //     Object.entries(it).forEach(([resource, actions]) => {
    //         const current: any = { resource };
    //         allActions.forEach((key) => current[key] = actions.has(key));
    //
    //         rules.push(current);
    //     });
    //
    //     return rules;
    // }));

    constructor() {
        super(defaultState, globalStore, inject(AclService));
    }

    private addInherited(groups: any[], visited: Set<number>): string[] {
        const set = new Set<string>();
        groups.forEach((group) => {
            if (!visited.has(group.id)) {
                visited.add(group.id);
                group.inherited = this.addInherited(group.extending, visited);
            }
            group.inherited.forEach((it: string) => set.add(it));
            (group.rules || []).forEach((rule: RuleObject) => {
                set.add(`${rule.resource}${KEY_JOIN}${rule.action}`);
            });
        });

        return Array.from(set);
    }

}
